import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { forwardRef } from 'react';
import { AbstractColumn } from '../AbstractColumn/AbstractColumn';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColumnWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractColumn, Object.assign({}, rest, {
    ref: ref,
    columnType: "wrapper",
    children: children
  }));
});
ColumnWrapper.displayName = 'ColumnWrapper';